import { useNavigate } from "react-router-dom";
import { Check, Zap, Crown, Sparkles, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const PRO = ["Live AI Tactical Coach", "Post-Match Reviews", "Career Mode & Road To Pro", "Auto Clips & AI Scout", "100 GB Cloud Storage"];
const CREATOR = ["Everything in Pro", "Content Studio & Highlight Reels", "AI Titles, Captions & Scripts", "Priority AI Processing", "500 GB Cloud Storage"];

export function PricingPreview({ deal }) {
    const navigate = useNavigate();
    const go = () => navigate("/register");
    return (
        <section id="pricing" className="py-24 md:py-32 border-t border-white/10" data-testid="pricing-preview">
            <div className="max-w-5xl mx-auto px-5 md:px-10">
                <div className="text-center mb-10">
                    <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-volt mb-3">Plans</p>
                    <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-white">Start free for 7 days.</h2>
                    <p className="text-muted-foreground mt-3">
                        Card required, $0 for 7 days, cancel anytime.{" "}
                        {deal && <span className="text-volt">Today: {deal.desc} with code {deal.code}.</span>}
                    </p>
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                    <PlanCard icon={Zap} name="WhiteWater Pro" price="14.99" sub="For ranked grinders" feats={PRO} onGo={go} testid="pricing-pro-cta" />
                    <PlanCard icon={Crown} name="WhiteWater Creator" price="24.99" sub="For streamers & creators" feats={CREATOR} onGo={go} testid="pricing-creator-cta" popular />
                </div>
                <p className="text-center text-xs text-muted-foreground mt-8 flex items-center justify-center gap-1.5">
                    <ShieldCheck className="w-4 h-4 text-success" /> No anti-cheat risk · Cancel anytime · Secure payments by Stripe
                </p>
            </div>
        </section>
    );
}

function PlanCard({ icon: Icon, name, price, sub, feats, onGo, testid, popular }) {
    return (
        <div className={cn("relative rounded-sm border bg-surface p-7", popular ? "border-2 border-volt/60 shadow-[0_0_30px_rgba(0,194,255,0.12)]" : "border-white/10")}>
            {popular && <span className="absolute -top-3 left-7 text-[10px] font-mono uppercase px-2.5 py-1 rounded-sm bg-volt text-black font-bold">Most Popular</span>}
            <div className="flex items-center gap-2 mb-1"><Icon className="w-5 h-5 text-volt" /><h3 className="font-heading text-xl font-bold text-white">{name}</h3></div>
            <p className="text-sm text-muted-foreground mb-4">{sub}</p>
            <div className="mb-5"><span className="font-heading text-4xl font-bold text-white">${price}</span><span className="text-muted-foreground text-sm">/month</span></div>
            <button onClick={onGo} data-testid={testid}
                className="w-full h-11 rounded-sm bg-volt text-black font-semibold hover:bg-[#33ceff] flex items-center justify-center gap-2 transition-colors">
                <Sparkles className="w-4 h-4" /> Start 7-Day Free Trial
            </button>
            <ul className="mt-6 space-y-2.5">
                {feats.map((f) => <li key={f} className="flex items-start gap-2 text-sm text-muted-foreground"><Check className="w-4 h-4 text-success mt-0.5 shrink-0" />{f}</li>)}
            </ul>
        </div>
    );
}
